export default "__VITE_ASSET__CSn_p3jx__"